import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    inspeccion_plan: null,
    citaForm: {
        fecha: null,
        hora: null,
        ubicacion: null,
        perito_id: null
    }
};
const mutations = {
    updateField,
    updateInspeccion: (state, payload) => {
        state.inspeccion_plan = payload.tipo_plan;
        if(payload.tipo_plan == 'pagada'){
            state.citaForm = payload.inspeccion_mecanica;
        }
    },
    changeInspeccionPlan: (state, payload) => {
        state.inspeccion_plan = payload;
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
